(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/confetti/assets/javascripts/confetti.js') >= 0) return;  svs.modules.push('/components/tur/confetti/assets/javascripts/confetti.js');
"use strict";


(function (svs) {
  'use strict';

  svs.tur = svs.tur || {};
  svs.tur.confetti = (() => {
    let confettiAnimation;
    let preventReplace = false;
    let step;
    let onWindowResize;
    const start = options => {
      var _options$colors;
      let NUM_CONFETTI;
      let w;
      let h;
      const autoStopTime = 5000;
      options = options || {};
      preventReplace = false;
      if (!$('.confetti-canvas').length) {
        $('body').append("<canvas id=\"confetti-canvas\" class=\"confetti-canvas ".concat(options.cssClass ? options.cssClass : '', "\"></canvas>"));
      }
      NUM_CONFETTI = svs.core.detect.formfactor.mobile() ? 150 : 500;
      NUM_CONFETTI = options.numConfetti || NUM_CONFETTI;
      const delay = options.delay || 1000;
      const COLORS = (_options$colors = options.colors) !== null && _options$colors !== void 0 ? _options$colors : [[85, 71, 106], [230, 0, 0], [219, 56, 83], [244, 92, 68], [248, 182, 70]];
      const PI_2 = 2 * Math.PI;
      const canvas = document.getElementById('confetti-canvas');
      onWindowResize = () => {
        w = canvas.width = window.innerWidth;
        return h = canvas.height = window.innerHeight;
      };
      $(window).resize(onWindowResize);
      const context = canvas.getContext('2d');
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
      const range = (a, b) => (b - a) * Math.random() + a;
      const drawCircle = (x, y, r, style) => {
        context.beginPath();
        context.arc(x, y, r, 0, PI_2, false);
        context.fillStyle = style;
        return context.fill();
      };
      const xpos = 0.5;
      const Confetti = function () {
        function Confetti() {
          this.style = COLORS[~~range(0, 5)];
          this.rgb = "rgba(".concat(this.style[0], ",").concat(this.style[1], ",").concat(this.style[2]);
          this.r = ~~range(2, 6);
          this.r2 = 2 * this.r;
          this.replace();
        }
        Confetti.prototype.replace = function () {
          this.opacity = 0;
          this.dop = 0.03 * range(1, 4);
          this.x = range(-this.r2, w - this.r2);
          this.y = range(-20, h - this.r2);
          this.xmax = w - this.r;
          this.ymax = h - this.r;
          this.vx = range(0, 2) + 8 * xpos - 5;
          return this.vy = 0.7 * this.r + range(-1, 1);
        };
        Confetti.prototype.draw = function () {
          let ref;
          this.x += this.vx;
          this.y += this.vy;
          this.opacity += this.dop;
          if (this.opacity > 1) {
            this.opacity = 1;
            this.dop *= -1;
          }
          if ((this.opacity < 0 || this.y > this.ymax) && !preventReplace) {
            this.replace();
          }
          if (!((ref = this.x) > 0 && ref < this.xmax)) {
            this.x = (this.x + this.xmax) % this.xmax;
          }
          return drawCircle(~~this.x, ~~this.y, this.r, "".concat(this.rgb, ",").concat(this.opacity, ")"));
        };
        return Confetti;
      }();
      const confetti = (() => {
        let i;
        const results = [];
        for (i = 0; i < NUM_CONFETTI; i++) {
          results.push(new Confetti());
        }
        return results;
      })();
      step = () => {
        let c;
        let j;
        let len;
        confettiAnimation = requestAnimationFrame(step);
        context.clearRect(0, 0, w, h);
        const results = [];
        for (j = 0, len = confetti.length; j < len; j++) {
          c = confetti[j];
          results.push(c.draw());
        }
        return results;
      };
      cancelAnimationFrame(confettiAnimation);
      if (options.preventDelay) {
        confettiAnimation = requestAnimationFrame(step);
      } else {
        setTimeout(() => {
          confettiAnimation = requestAnimationFrame(step);
        }, delay);
      }
      if (!options.preventAutoStop) {
        setTimeout(() => {
          stop();
        }, autoStopTime + delay);
      }
    };
    const pause = () => {
      cancelAnimationFrame(confettiAnimation);
    };
    const resume = () => {
      confettiAnimation = requestAnimationFrame(step);
    };
    const destroy = () => {
      cancelAnimationFrame(confettiAnimation);
      $(window).off('resize', onWindowResize);
      $('.confetti-canvas').remove();
    };
    const stop = () => {
      preventReplace = true;
    };
    return {
      makeItRain: start,
      pause,
      resume,
      destroy,
      stop
    };
  })();
})(svs, _);

 })(window);